import {
  closeOverlay,
  openOverlay,
} from "./OverlayManager";

// NapflixOS System Status v12
// Runtime state for the read-only OS status panel.
let systemStatusState = {
  open: false,
  openedAt: null,
};

const listeners = new Set();

const notifyListeners = () => {
  listeners.forEach((listener) => listener(systemStatusState));
};

const syncSystemStatusOverlay = () => {
  if (!systemStatusState.open) {
    closeOverlay("napflix-system-status");
    return;
  }

  openOverlay({
    id: "napflix-system-status",
    type: "system-status",
    priority: 85,
    modal: true,
    focusTrap: false,
    payload: null,
  });
};

export function getSystemStatusState() {
  return systemStatusState;
}

export function setSystemStatusState(partial) {
  systemStatusState = {
    ...systemStatusState,
    ...partial,
  };

  syncSystemStatusOverlay();
  notifyListeners();
  return systemStatusState;
}

export function subscribeSystemStatus(listener) {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}

export function openSystemStatus() {
  return setSystemStatusState({
    open: true,
    openedAt: Date.now(),
  });
}

export function closeSystemStatus() {
  return setSystemStatusState({
    open: false,
    openedAt: null,
  });
}

export function toggleSystemStatus() {
  if (systemStatusState.open) {
    return closeSystemStatus();
  }

  return openSystemStatus();
}
